import { useEffect } from "react";
import NProgress from "nprogress";
import { Box, Skeleton, Stack } from "@mui/material";

import PageContainer from "src/components/PageContainer";

// skeleton lives inside PageContainer so its max-width and
// horizontal padding match the final page, preventing a layout jump once the
// lazy chunk resolves.
function SuspenseLoader() {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <PageContainer sx={{ mt: 4 }}>
      {/* Page title skeleton */}
      <Skeleton variant="text" width={180} height={32} sx={{ mb: 0.5 }} />
      <Skeleton variant="text" width={300} height={18} sx={{ mb: 3 }} />

      {/* Card skeleton */}
      <Box
        sx={{
          borderRadius: "16px",
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden"
        }}
      >
        <Box sx={{ p: 3 }}>
          <Stack direction="row" spacing={2} sx={{ mb: 3 }} flexWrap="wrap">
            <Skeleton variant="rounded" width={220} height={56} sx={{ borderRadius: "8px" }} />
            <Skeleton variant="rounded" width={220} height={56} sx={{ borderRadius: "8px" }} />
            <Skeleton variant="rounded" width={220} height={56} sx={{ borderRadius: "8px" }} />
          </Stack>
          <Stack direction="row" spacing={2} sx={{ mb: 3 }} flexWrap="wrap">
            <Skeleton variant="rounded" width={220} height={56} sx={{ borderRadius: "8px" }} />
            <Skeleton variant="rounded" width={220} height={56} sx={{ borderRadius: "8px" }} />
          </Stack>
          <Stack direction="row" spacing={3} flexWrap="wrap">
            {[60, 80, 72, 56, 68].map((w, i) => (
              <Stack key={i} alignItems="center" spacing={0.5}>
                <Skeleton variant="rounded" width={42} height={22} sx={{ borderRadius: "11px" }} />
                <Skeleton variant="text" width={w} height={16} />
              </Stack>
            ))}
          </Stack>
        </Box>
      </Box>
    </PageContainer>
  );
}

export default SuspenseLoader;
